import ZDApproval from './ZDApproval'

export default ZDApproval
